import {Api} from '@/core/api.js';
const api = new Api();

const state = {
    budget: {},
    payments: {},
    services: {},
    discounts: {},
    paymentsCard: {},
    redsys_params: {}
}

const getters = {
    
    getBudget (state) {
        return state.budget;
    },

    get_service_by_id: (state, getters, rootState) => (id) => {
    if( typeof id !== 'undefined' ) return state.services[id]
    return false
    },

    get_services: (state, getters, rootState) => (id) => {
        var oList = {}
        for( var k in state.services ){
            var service = state.services[k]
            if( typeof id === 'undefined' || id == service.type ){
                oList[k] = service
            }
        }
        return oList;
      },

    get_discounts: (state, getters, rootState) => (id) => {
    var oList = {}
    for( var k in state.discounts ){
        var discount = state.discounts[k]
        if( typeof id === 'undefined' || id == discount.type ){
            oList[k] = discount
        }
    }
    return oList;
    },

    get_team_budget_by_id: (state, getters, rootState) => (id) => {
    if (typeof state.team_budgets[id] !== 'undefined') return state.team_budgets[id];
    return false;
    },

    get_person_budget_by_id: (state, getters, rootState) => (id) => {
    if (typeof state.person_budgets[id] !== 'undefined') return state.person_budgets[id];
    return false;
    },

    getPayments: (state, getters, rootState) => {
        return state.payments;
    },
    
    getPaymentsCard: (state, getters, rootState) => {
        return state.paymentsCard;
    },

    get_discount_by_id: (state, getters, rootState) => (id) => {
        if( typeof id !== 'undefined' ) return state.discounts[id]
        return false
    },

    getRedsysParams: ( state, getter, rootState ) => {
        return state.redsys_params;
    },

}

const actions = {

    loadBudget: ({commit},params) => {
        return api.get('finances/budget/' + params.event_id + '/' + params.type + '/' + params.entity_id).then(function(response){
            return commit('setBudget',response.data);
        });
    },

    loadPayment: ({commit},params) => {
        return api.get('finances/payment/' + params.event_id + '/' + params.type + '/' + params.entity_id).then(function(response){
            return commit('setPayments',response.data);
        });
    },

    loadServices( { commit }, event_id ){
        var path = `finances/services/${event_id}`;
        return api.get(path).then(function (response) {
          if (response.status) {
            return commit('setServices', response.data);
          }
        });
    },

    loadDiscounts( { commit }, event_id ){
    var path = `finances/discount/${event_id}`;
    return api.get(path).then(function (response) {
        if (response.status) {
        return commit('setDiscounts', response.data);
        }
    });
    },

    payments_team_card({ commit, rootState }, budget_id) {

        // var iEventID = rootState.events.current_event.id;
        var iEventID = rootState.user.user.event_id;
        // var iType = (rootState.events.current_event.is_campus) ? 3 : 2;
        var iType = 2;
        var iEntityID = budget_id;
    
        var path = `finances/budget/payment/${iEventID}/${iType}/${iEntityID}` ;
        return api.get(path).then(function (response) {
          if (response.status) {
            return commit('setPaymentsCard', response.data);
          }
          return commit('setPaymentsCard', []);
        });
      },
      payments_club_card({ commit, rootState }, budget_id) {
        var iEventID = rootState.events.current_event.id;
        var iType = 1;
        var iEntityID = budget_id;
    
        var path = `finances/budget/payment/${iEventID}/${iType}/${iEntityID}` ;
        return api.get(path).then(function (response) {
          if (response.status) {
            return commit('setPaymentsCard', response.data);
          }
          return commit('setPaymentsCard', []);
        });
      },
      payments_person_card({ commit, rootState }, budget_id) {
        var iEventID = rootState.current_event.id;
        var iType = 3;
        var iEntityID = budget_id;

        var path = `finances/budget/payment/${iEventID}/${iType}/${iEntityID}` ;
        return api.get(path).then(function (response) {
          if (response.status) {
            return commit('setPaymentsCard', response.data);
          }
          return commit('setPaymentsCard', []);
        });

      },

      go_to_redsys: ({commit},params) => {
        return api.get(`finances/${params.event_id}/redsys/generate/${params.entity_type}/${params.entity_id}`).then(function(response){
            return commit('setRedsysParams',response.data);
        });
      }

}

const mutations = {

    setBudget(state,data){
        var budget = { ...state.budget };
        state.budget = data;
    },

    setServices(state, data) {
        var services = { ...state.services };
        state.services = data;
    },

    setDiscounts(state, data) {
        var discounts = { ...state.discounts };
        state.discounts = data;
    },

    setPayments(state, data) {
        var payments = {...state.payments};
        state.payments = data;
    },

    setPaymentsCard(state, data) {
        var paymentsCard = {...state.paymentsCard};
        state.paymentsCard = data;
    },

    setRedsysParams( state, value ) {
        state.redsys_params = value;
    },

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}